import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, watch, ref, } from 'vue';
import { i18n } from '@/locales';
import vuexStore from '@/vuex-store';
import VerticalDividedDialog from '@/templates/VerticalDividedDialog.vue';
import WorkerProfitDetailDialogController from '@/views/Dialog/WorkerProfitDetailDialog/WorkerProfitDetailDialogController.vue';
import WorkerProfitDetailTable from '@/views/Dialog/WorkerProfitDetailDialog/WorkerProfitDetailTable.vue';
const lc = 'views.worker.worker_profit_detail_dialog.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const locale = {
            title: i18n.t(`${lc}title`),
        };
        const isDialogOpen = computed(() => vuexStore.getters['workerProfitDetailDialog/isDialogOpen']);
        const formattedWorkerName = computed(() => vuexStore.getters['workerProfitDetailDialog/formattedWorkerName']);
        /**
             * 다이얼로그 종료시 초기화
             */
        const handleClickCancelDialogBtn = () => {
            vuexStore.dispatch('workerProfitDetailDialog/resetStore');
        };
        const isFetching = ref(true);
        const isError = ref(false);
        const getWorkerProfitByWorkerCodeList = async () => {
            vuexStore.dispatch('workerProfitDetailDialog/resetWorkerProfitByWorkerCodeList');
            isFetching.value = true;
            isError.value = false;
            try {
                await vuexStore.dispatch('workerProfitDetailDialog/getWorkerProfitByWorkerCodeList');
            }
            catch {
                isError.value = true;
            }
            finally {
                isFetching.value = false;
            }
        };
        const filterOption = computed(() => vuexStore.state.workerProfitDetailDialog.filterOption);
        const pageNumber = computed(() => vuexStore.state.workerProfitDetailDialog.pageNumber);
        const sortOption = computed(() => vuexStore.state.workerProfitDetailDialog.sortOption);
        /**
             * 필터 변경 시 라이더 수익 상세 목록 조회 (다이얼로그 닫혀있으면 x)
             */
        watch(() => ({
            ...filterOption.value,
            sortOption,
        }), async () => {
            if (!isDialogOpen.value) {
                return;
            }
            // 필터 변경시 1 페이지가 아니면 페이지 초기화
            const firstPage = 1;
            if (pageNumber.value !== firstPage) {
                // @ts-ignore
                vuexStore.dispatch('workerProfitDetailDialog/setPageNumber', firstPage);
                return;
            }
            await getWorkerProfitByWorkerCodeList();
        }, {
            deep: true,
        });
        /**
             * 페이지 변경 시 라이더 수익 상세 목록 조회 (다이얼로그 닫혀있으면 x)
             */
        watch(() => pageNumber.value, async () => {
            if (!isDialogOpen.value) {
                return;
            }
            await getWorkerProfitByWorkerCodeList();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(VerticalDividedDialog, {
                "is-open": isDialogOpen.value,
                "on-cancel": handleClickCancelDialogBtn,
                "is-divided": false,
                "has-footer": false,
                "dialog-css-class": "width-lg ratio-full"
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(locale.title) + " / " + _toDisplayString(formattedWorkerName.value), 1 /* TEXT */)
                ]),
                leftSubTitle: _withCtx(() => [
                    _createVNode(WorkerProfitDetailDialogController)
                ]),
                leftContent: _withCtx(() => [
                    _createVNode(WorkerProfitDetailTable, {
                        "is-error": isError.value,
                        "is-fetching": isFetching.value
                    }, null, 8 /* PROPS */, ["is-error", "is-fetching"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-open"]));
        };
    }
});
